import { TpvsPageContainer } from '@/Store/ui/organisms'

export const TpvsPage = (): JSX.Element => {
  return (<TpvsPageContainer />)
}
